import { ArcElement, Chart as ChartJS, DoughnutController, Tooltip } from "chart.js";
import React from "react";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, DoughnutController, Tooltip);

type BudgetDoughnutChartProps = {
	// `chartValue` rather than `value`: arc geometry is a pixel proportion, so a plain
	// number is correct here. Naming it distinctly keeps a caller from reaching for it
	// when it wants the displayable amount.
	data: { label: string; chartValue: number; color: string }[];
};

const chartOptions = {
	cutout: "70%",
	responsive: true,
	maintainAspectRatio: true,
	plugins: {
		legend: { display: false },
		tooltip: { enabled: false },
	},
} as const;

export const BudgetDoughnutChart: React.FC<BudgetDoughnutChartProps> = ({ data }) => {
	const chartData = {
		labels: data.map((item) => item.label),
		datasets: [
			{
				data: data.map((item) => item.chartValue),
				backgroundColor: data.map((item) => item.color),
				borderWidth: 0,
				hoverOffset: 2,
			},
		],
	};

	return (
		<div className="h-[180px] w-[180px] shrink-0">
			<Doughnut data={chartData} options={chartOptions} />
		</div>
	);
};
